export enum DriverTableButtons {
  Delete = 'DeleteDriverUser',
  Invite = 'RegisterDriverUser',
  ResendPassword = 'ResetDriverUserPassword'
}
